import { useCallback } from 'react';
import { AncestorIdData, AncestorNameData } from 'modules/domains';
import { NewFolderModal } from 'ui/indexPages/modals/NewFolderModal';
import { useModalContext } from 'utils/contexts/modal';
import { useListsContext } from '../../contexts';
import { useListTreeViewQuery } from '../../hooks/folders/useListTreeViewQuery';
import { useCreateListFolder } from '../../hooks/folders';
import { MAX_FOLDER_NAME_LENGTH } from '../../constants';

export const CreateListFolderModal = () => {
  const { hideModal } = useModalContext();
  const { folderId, rootFolderId, refetch } = useListsContext();
  const createListFolder = useCreateListFolder();

  const onConfirm = useCallback(
    async (newFolderName: string, newFolderDestination: AncestorNameData & AncestorIdData) => {
      hideModal();
      await createListFolder(newFolderName, newFolderDestination);
      refetch();
    },
    [createListFolder, hideModal, refetch],
  );

  return (
    <NewFolderModal
      maxNameLength={MAX_FOLDER_NAME_LENGTH}
      defaultDestinationFolderId={folderId}
      onClose={hideModal}
      onConfirm={onConfirm}
      rootFolderId={rootFolderId}
      treeViewQuery={useListTreeViewQuery}
    />
  );
};
